import React, { Component } from 'react';

import Intro from './components/intropage/Intro';
import GamePage from './components/gamepage/GamePage';
import * as Utils from './utils/utils';

//import {isIframed} from './utils/gsntv';

import './../scss/App.scss';
import { trackingWrapper } from './utils/analytics';
import IronSourceInitializerContainer from './containers/IronSourceInitializerContainer';




class App extends Component {

	constructor(props){
		super(props);

		this.dayOfWeek = "";

		this.state = {
			"key": 0,
			"dataReady" : false,
			"dayOfWeek": "monday",
			"showIntroPage": false,
			"showGamePage": false,
			"isMuted": false
		}

		//

		this.handleIntroInComplete = this.handleIntroInComplete.bind(this);
		this.handleIntroOutComplete = this.handleIntroOutComplete.bind(this);
		this.handleSoundToggle = this.handleSoundToggle.bind(this);

		//

		window.ppz.app = this;
	}

	componentDidMount(){
		//console.log("componentDidMount");
		this.initPuzzleDay();

		// tracking
		trackingWrapper('event', 'PPZgame-page-loaded', {'event_category':'people-puzzler-game'});

		// resizing for layout
		window.$(window).resize(() => {
			this.forceUpdate();
		});

		// mute sounds if debug mode
		if(window.ppz.debug){
			this.muteSounds();
		}

	}

	initPuzzleDay(day){
		if(day === undefined){
			const d = new Date();
			let dayIndex = d.getDay();

			const dayArray = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

			if(dayIndex === 0 || dayIndex === 6){
				dayIndex = 5; // if current day is saturday or sunday, make it friday
			}

			this.dayOfWeek = dayArray[dayIndex];
		}
		else {
			this.dayOfWeek = day;
		}

		this.initData();
	}

	initData(){
		console.log("App :: initData - v16 - day:", this.dayOfWeek);

		window.ppz.dayOfWeek = this.dayOfWeek;

		const _this = this;

		const jsonHash = new Date().getTime();

		console.log("jsonHash", jsonHash);

		window.$.when(
			// load config.json
			window.$.getJSON(("data/config.json?v=" + jsonHash), function(data) {
				window.ppz.config = {...data};
				window.videoAdsPool = [...data.videoAd.videos];
			})
		).then(function() {
			let puzzlePath = window.ppz.config.puzzleData.puzzlePaths[_this.dayOfWeek];
			let jsonName = window.ppz.config.puzzleData.jsonFileName;

			if(window.ppz.debug){
				console.log("use debug json path");

				puzzlePath = window.ppz.config.debugData.puzzlePaths[_this.dayOfWeek];
				jsonName = window.ppz.config.debugData.jsonFileName;
			}

			window.ppz.puzzlePath = puzzlePath;

			let puzzleJSONpath = puzzlePath + jsonName + "?v=" + jsonHash;
			
			window.$.when(
				window.$.getJSON(puzzleJSONpath, function(data) {
					window.ppz.puzzleData = {...data};
				})
			).then(function() {

				if(window.ppz.debug || window.ppz.firstLoad === false){
					_this.setState({
						"dataReady": true,
						"showIntroPage": false,
						"showGamePage": true,
						"key": (_this.state.key + 1)
					});
				}
				else {
					_this.setState({
						"dataReady": true,
						"showIntroPage": true,
						"showGamePage": false,
						"key": (_this.state.key + 1)
					});
				}
			});
		});
	}

	handleIntroOutComplete(){
		this.setState({
			"showIntroPage": false
		});
	}

	handleIntroInComplete(){
		this.setState({
			"showGamePage": true
		});
	}

	renderIntroPage(){
		if(this.state.showIntroPage === true){
			return (
				<Intro handleIntroComplete={this.handleIntroComplete} handleIntroInComplete={() => this.handleIntroInComplete()} handleIntroOutComplete={() => this.handleIntroOutComplete()} />
			)
		}
	}

	renderGamePage(){
		if(this.state.showGamePage === true){
			return (
				<GamePage puzzleData={window.ppz.puzzleData} />
			)
		}
	}

	muteSounds(){
		this.setState({
			"isMuted": true
		});

		window.Howler.mute(true);
	}

	handleSoundToggle(){
		if(this.state.isMuted){
			this.setState({
				"isMuted": false
			});

			window.Howler.mute(false);
		}
		else {
			this.setState({
				"isMuted": true
			});

			window.Howler.mute(true);
		}
	}

	renderDebug(){
		if(window.ppz.debug && window.ppz.puzzleData !== undefined){
			return(
				<div className="debug-json-data"><b>Title:</b> {window.ppz.puzzleData.title} &nbsp;&nbsp;&nbsp; <b>Number:</b> {window.ppz.puzzleData.number} &nbsp;&nbsp;&nbsp; <b>Day:</b> {this.dayOfWeek} &nbsp;&nbsp;&nbsp; <b>Stack:</b> {window.ppz.puzzleData.stack}</div>
			);
		}
	}

	render() {
		const availWidth = window.$(window).width();
		const availHeight = window.$(window).height();
		const widthHeightRatio = availWidth / availHeight;

		let layoutMode = "";

		if(widthHeightRatio <= .65){
			layoutMode = "tablet phone";
		}
		else if(widthHeightRatio <= .85){
			layoutMode = "tablet";
		}

		layoutMode += " " + Utils.detectDeviceType();

		//

		let soundToggleStyle = " fas fa-volume-up";

		if(this.state.isMuted){
			soundToggleStyle = " fas fa-volume-mute";
		}

		//console.log("widthHeightRatio", widthHeightRatio);

		return (
			<div className={"main_wrapper " + layoutMode} key={this.state.key}>
				<div className="content">
					<div className="pp-logo-container">
						<div className="pp-logo" />
					</div>
					{ this.renderGamePage() }
					{ this.renderIntroPage() }
					<div className={"soundToggle" + soundToggleStyle} onClick={() => this.handleSoundToggle()}></div>
				</div>
				{this.renderDebug()}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js